
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/step-guide/facility-initiation",
      function () {
        return require("private-next-pages/step-guide/facility-initiation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/step-guide/facility-initiation"])
      });
    }
  